module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_vm._v("网彩彩票")]), _vm._v(" "), _c('swipe', {
    attrs: {
      "images": _vm.images
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lottery-wrap border-1px"
  }, [_c('div', {
    staticClass: "item-wrap"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/ssc"
    }
  }, [_c('span', {
    staticClass: "icon ssc"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("双色球")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/dlt"
    }
  }, [_c('span', {
    staticClass: "icon dlt"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("大乐透")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/d3"
    }
  }, [_c('span', {
    staticClass: "icon d3"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("3D")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/k3"
    }
  }, [_c('span', {
    staticClass: "icon k3"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("快3")])])], 1)]), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13aac572"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 62
// module chunks = 0